module.exports = "/build/web/svg/social/twitter.efad0cc4573f592b801dd78617e89ad5.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/twitter.svg
// module id = 201
// module chunks = 24